import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import { Checkbox, type SelectChangeEvent, Typography } from '@mui/material'
import {
  CountBadge,
  SelectedValueBox,
  StyledFormControl,
  StyledMenuItem,
  StyledSelect,
} from './FilterSelect.styles'

interface FilterSelectProps {
  selectedValues: string[]
  onChange: (val: string[]) => void
  options: string[]
  label: string
}

const FilterSelect = ({
  selectedValues,
  onChange,
  options,
  label,
}: FilterSelectProps) => {
  const isEmpty = selectedValues.length === 0
  const selectId = 'filter-select'
  const labelId = `${selectId}-label`
  return (
    <StyledFormControl>
      <StyledSelect
        disabled={options.length === 0}
        id={selectId}
        labelId={labelId}
        data-testid="select-element"
        multiple
        displayEmpty
        IconComponent={ArrowDropDownRoundedIcon}
        autoWidth
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
        value={selectedValues}
        selectedCount={selectedValues.length}
        onChange={(e: SelectChangeEvent<string[]>) =>
          onChange(e.target.value as string[])
        }
        inputProps={{
          'aria-label': labelId,
          'aria-multiselectable': true,
        }}
        renderValue={() => (
          <SelectedValueBox>
            {!isEmpty && (
              <CountBadge data-testid="count-badge">
                {selectedValues.length}
              </CountBadge>
            )}
            <Typography variant="subtitle2">{label}</Typography>
          </SelectedValueBox>
        )}
      >
        {options?.map((opt) => {
          const trimmedOpt = opt?.trim()
          const isSelected = selectedValues.includes(trimmedOpt)

          return (
            <StyledMenuItem
              key={trimmedOpt}
              value={trimmedOpt}
              aria-selected={isSelected}
            >
              <Checkbox
                checked={isSelected}
                sx={{ padding: 0 }}
                disableRipple
              />
              <Typography variant="body1">{trimmedOpt}</Typography>
            </StyledMenuItem>
          )
        })}
      </StyledSelect>
    </StyledFormControl>
  )
}

export default FilterSelect
